<template>
  <div>
    <div class="form-row">
      <div class='row'>
        <div class='col-10'>
          <img style="display:none;" id="bigpic" src="bigpic" class="car-image"/>
        </div>
        <!--<div class='col-2' v-if='img_string=="關閉照片"'>
            <h3> <kbd>車別 </kbd></h3>
            <div class="custom-control custom-radio">
              <input v-model="carName" type="radio" class="custom-control-input" id="defaultGroupExample1" value="小型車">
              <label class="custom-control-label" for="defaultGroupExample1"><h5>小型車</h5></label>
            </div>
            <div class="custom-control custom-radio">
              <input v-model="carName" type="radio" class="custom-control-input" id="defaultGroupExample2" value="摩托車">
              <label class="custom-control-label" for="defaultGroupExample2"><h5>摩托車</h5></label>
            </div>
            <div class="custom-control custom-radio">
              <input v-model="carName" type="radio" class="custom-control-input" id="defaultGroupExample3" value="重型機車">
              <label class="custom-control-label" for="defaultGroupExample3"><h5>重型機車</h5></label>
            </div>
            <div class="custom-control custom-radio">
              <input v-model="carName" type="radio" class="custom-control-input" id="defaultGroupExample4" value="其它">
              <label class="custom-control-label" for="defaultGroupExample4"><h5>其它</h5></label>
            </div>
            <button class="btn btn-primary" @click="updateCarName">更新</button>
        </div>-->
        
      </div>
      <button class="btn btn-primary" @click="showImg">{{img_string}}</button>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button class="btn btn-danger" @click="returnModify" :disabled="this.$store.state.user.user.username=='estcheck'">退回修正</button>
      <!--&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button class="btn btn-info" @click="uncertain">無法開單</button>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <button class="btn btn-success" @click="pass">未違規</button>-->
    </div>
  </div>
</template>

<script>
import server from '@/config';

export default {
  name: 'ConfirmCheckDetail',
  data() {
    return {
      status: null,
      sourceOfPicture: '',
      img_string: '顯示照片',
      //carName: '',
      randomNum: '',
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
  components: {
  },
  async mounted() {
    var img = document.getElementById('bigpic')
    this.randomNum = Math.random();
    this.sourceOfPicture = `/media/interval/done/${this.rowData.fixed_link_code.fixed_link_code}/${this.rowData.img_filename}?t=${this.randomNum}`;
    this.img_string="關閉照片";
    img.src = this.sourceOfPicture;
    img.style.display = "block";
    img.class="car-image";  
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  methods: {
    showImg() {
      var img = document.getElementById('bigpic')
      this.randomNum = Math.random();
      this.sourceOfPicture = `/media/interval/done/${this.rowData.fixed_link_code.fixed_link_code}/${this.rowData.img_filename}?t=${this.randomNum}`;
      console.log(this.sourceOfPicture)
      if(img.style.display=="none")
      {
        this.img_string="關閉照片";
        img.src = this.sourceOfPicture;
        img.style.display = "block";
        img.class="car-image";
      }
      else
      {
        this.img_string="顯示照片";
        img.style.display = "none";
      }
    },
    returnModify() {
      this.instance.patch(`/api/interval-speed-data/${this.rowData.id}/`, {
        xactno: this.rowData.xactno,
        status: "t0",
      })
      .then(() => {
        //this.$parent.refresh();
        /*this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功, 已退回',
        });*/
        this.$parent.refresh();
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data,
        });
      });    
    },
    /*
    breakLaw() {
      this.instance.patch(`/api/interval-speed-data/${this.rowData.id}/`, {
        xactno: this.rowData.xactno,
        status: "t1",
        user: this.$store.state.user.user.username,
      })
      .then(() => {
        this.$parent.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功, 已開單',
        });
        this.$parent.refresh();
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data,
        });
      });
    },
    uncertain() {
      this.instance.patch(`/api/interval-speed-data/${this.rowData.id}/`, {
        xactno: this.rowData.xactno,
        status: "t3",
        user: this.$store.state.user.user.username,
      })
      .then(() => {
        this.$parent.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });
        this.$parent.refresh();
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data,
        });
      });
    },
    pass() {
      this.instance.patch(`/api/interval-speed-data/${this.rowData.id}/`, {
        xactno: this.rowData.xactno,
        status: "t2",
        user: this.$store.state.user.user.username,
      })
      .then(() => {
        this.$parent.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });
        this.$parent.refresh();
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data,
        });
      });
    },
    updateCarName() {
      this.instance.patch(`/api/interval-speed-data/${this.rowData.id}/`, {
        xactno: this.rowData.xactno,
        car_name: this.carName,
      })
      .then(() => {
        this.$parent.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '更新成功',
        });
        this.$parent.refresh();
      })
      .catch((err) => {
        this.$store.commit('SET_MESSAGE', {
          type: 'error',
          context: err.response.data,
        });
      });
    },
    */
  },
};
</script>

<style lang="sass">
.car-image
  width: 100%
</style>



// WEBPACK FOOTER //
// ConfirmCheckDetail.vue?072fabfc